import { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { authLogout } from '../../../redux/actions/auth' // Adjust path based on your project structure

const useTokenExpiration = () => {
  const dispatch = useDispatch()
  const tokenInfo = useSelector((state) => state.auth.info) // Select token info from Redux
  const timerRef = useRef(null)

  useEffect(() => {
    if (!tokenInfo || !tokenInfo.created || !tokenInfo.ttl) return

    const { created, ttl } = tokenInfo
    const createdAt = new Date(created).getTime() // Convert ISO string to timestamp
    const now = Date.now()
    const remainingTime = ttl * 1000 - (now - createdAt) // Convert ttl to milliseconds

    if (remainingTime <= 0 && ttl > 0) {
      dispatch(authLogout()) // Token already expired
      return
    }

    // Set timeout for logout
    timerRef.current =
      ttl > 0
        ? setTimeout(() => {
            dispatch(authLogout())
          }, remainingTime)
        : null

    if (ttl > 0)
      console.log(`Token will expire in ${remainingTime / 1000} seconds`)
    else console.log(`Permanent token`)

    // Cleanup function to clear timeout on unmount or token change
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [tokenInfo, dispatch]) // Re-run effect when token info changes
}

export default useTokenExpiration
